/**
 * Aviso de "la sesión expiró de verdad": el refresh fue RECHAZADO por la API.
 *
 * Lo emite `apiClient` una sola vez por refresh fallido, con `mutacion: true` si
 * alguna de las peticiones afectadas intentaba cambiar algo (cualquier método que
 * no sea GET/HEAD). Quien escucha (`SesionExpiradaAviso`) decide qué mostrar.
 *
 * Es un evento y no un cambio de estado, a propósito: vaciar el usuario de
 * `AuthSessionProvider` hace que `RoleGuard` pinte su fallback, lo que desmonta la
 * página —y con ella el modal abierto y lo que la persona escribió—; navegar al
 * login lo pierde igual.
 *
 * Mismo patrón que `perfil-actualizado.ts`, pero SIN `'use client'`: lo importa
 * `apiClient`, que también usan helpers de `lib/` sin directiva. Fuera del
 * navegador las dos funciones no hacen nada.
 */

const EVENTO = 'siiv-sesion-expirada';

export interface DetalleSesionExpirada {
	/** true si alguna petición afectada intentaba cambiar algo (no era GET/HEAD). */
	mutacion: boolean;
}

/** Avisa que la sesión expiró. No-op fuera del navegador. */
export function emitirSesionExpirada(detalle: DetalleSesionExpirada): void {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent<DetalleSesionExpirada>(EVENTO, { detail: detalle }));
}

/**
 * Se suscribe al aviso. Devuelve la función para desuscribirse, lista para
 * retornar desde un `useEffect`.
 */
export function suscribirSesionExpirada(alExpirar: (detalle: DetalleSesionExpirada) => void): () => void {
	if (typeof window === 'undefined') return () => {};

	const handler = (event: Event) => {
		alExpirar((event as CustomEvent<DetalleSesionExpirada>).detail);
	};
	window.addEventListener(EVENTO, handler);
	return () => window.removeEventListener(EVENTO, handler);
}
